module.exports = __webpack_public_path__ + "static/media/favicon.ceec5ec5.ico";